import React from 'react';
import { cardStyles } from './Card.styles';

const Card = ({
  children,
  variant = 'default',
  padding = 'md',
  hoverable = false,
  onClick,
  className = '',
  ...props
}) => {
  const baseClasses = cardStyles.base;
  const variantClasses = cardStyles.variants[variant];
  const paddingClasses = cardStyles.padding[padding];
  const hoverClasses = hoverable ? cardStyles.hoverable : '';
  const clickableClasses = onClick ? 'cursor-pointer' : '';

  return (
    <div
      onClick={onClick}
      className={`
        ${baseClasses}
        ${variantClasses}
        ${paddingClasses}
        ${hoverClasses}
        ${clickableClasses}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

// Sub-componentes para estruturar o Card
Card.Header = ({ children, className = '' }) => (
  <div className={`border-b border-gray-100 pb-4 mb-4 ${className}`}>
    {children}
  </div>
);

Card.Body = ({ children, className = '' }) => (
  <div className={className}>
    {children}
  </div>
);

Card.Footer = ({ children, className = '' }) => (
  <div className={`border-t border-gray-100 pt-4 mt-4 ${className}`}>
    {children}
  </div>
);

Card.Title = ({ children, className = '' }) => (
  <h3 className={`text-lg font-semibold text-gray-900 ${className}`}>
    {children}
  </h3>
);

Card.Description = ({ children, className = '' }) => (
  <p className={`text-sm text-gray-600 mt-1 ${className}`}>
    {children}
  </p>
);

export default Card;